
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/atmmachineprices",
      function () {
        return require("private-next-pages/atmmachineprices/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/atmmachineprices"])
      });
    }
  